<template>
    <div class="bg-gray relative z-0">
        <div class="page-container has-breadcrumb">
            <div class="px-8 md:px-5 py-5 ">
                <breadcrumb></breadcrumb>
            </div>
            <div class="px-8 md:px-5 py-5 ">
                <h1 class="mb-6">
                    Staff Management
                </h1>
                <admin-grid></admin-grid>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">
    import AdminGrid from './includes/AdminGrid.vue';
    import Breadcrumb from './includes/Breadcrumb.vue';
    import Vuex from 'vuex';

    export default {
        components: {
            AdminGrid,
            Breadcrumb
        },

        created: function () {
            this.setPaths([
                {
                    text: 'Sharp Admin',
                    name: 'adminClient',
                    isText: true
                }
            ]);
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
        },
        methods: {
            ...Vuex.mapMutations('layout', {
                setPaths: 'setPaths',
            }),
        }
    }
</script>
